"use strict";

exports.__esModule = true;
exports.CycleListItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Time = require("../../Time");
var _CurrentCycle = require("./CurrentCycle");
var _PastCycle = require("./PastCycle");
var _excluded = ["data"];
var _dec, _dec2, _class, _CycleListItem;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// Wait for upto 90 seconds delay in getting a new cycle event
var REALTIME_UPDATE_THRESHOLD_MILLIS = 90000;

/**
 * An item in a cycle list.
 */
var CycleListItem = exports.CycleListItem = (_dec = _Time.TimeContext.withContext, _dec2 = (0, _Time.withTimer)(1000), _dec(_class = _dec2(_class = (_CycleListItem = /*#__PURE__*/function (_Component) {
  function CycleListItem() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleClick = function (event) {
      var _this$props = _this.props,
        onClick = _this$props.onClick,
        classification = _this$props.classification;
      if (typeof onClick === "function") {
        onClick(classification, event);
      }
    };
    return _this;
  }
  _inheritsLoose(CycleListItem, _Component);
  var _proto = CycleListItem.prototype;
  _proto.abbreviateStateName = function abbreviateStateName(state) {
    if (state.id === "downtime.unplanned") {
      return "UDT";
    }
    if (state.id === "downtime.planned") {
      return "PDT";
    }
    return state.name;
  };
  _proto.isCurrent = function isCurrent(cycle) {
    var _this$props2 = this.props,
      data = _this$props2.data,
      now = _this$props2.now;
    if (now && now >= cycle.interval.startMillis && now < cycle.interval.endMillis + REALTIME_UPDATE_THRESHOLD_MILLIS) {
      return data && data.length ? cycle === data[data.length - 1] : true;
    }
    return false;
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      now = _this$props3.now,
      classification = _this$props3.classification;
    // eslint-disable-next-line no-unused-vars
    var _this$props4 = this.props,
      data = _this$props4.data,
      extra = _objectWithoutPropertiesLoose(_this$props4, _excluded);
    var isCurrent = this.isCurrent(classification);
    return isCurrent ? /*#__PURE__*/_react["default"].createElement(_CurrentCycle.CurrentCycle, _extends({}, extra, {
      now: now,
      isCurrent: true
    })) : /*#__PURE__*/_react["default"].createElement(_PastCycle.PastCycle, extra);
  };
  return CycleListItem;
}(_react.Component), _CycleListItem.defaultProps = {
  time: undefined
}, _CycleListItem)) || _class) || _class);